import PropTypes from 'prop-types';

import marketShape from './marketShape';

export default PropTypes.shape({
  betGroups: PropTypes.arrayOf(PropTypes.number),
  displayLayout: PropTypes.string,
  groups: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.number,
  isAllowedSpecifierAutoSelection: PropTypes.bool,
  mainPosition: PropTypes.number,
  markets: PropTypes.objectOf(marketShape),
  name: PropTypes.string,
  orderPosition: PropTypes.number,
  shortName: PropTypes.string,
  show: PropTypes.bool,
});
